
import img1 from '../images/svg/icon-1.svg'
import img2 from '../images/svg/icon-2.svg'
import img3 from '../images/svg/icon-3.svg'
import img4 from '../images/svg/icon-4.svg'



const dataPortfolio = [

    {
        id: 1,
        img: img1,
        title: 'Create your Avatar',
        desc: '당신만의 유니크한 아바타를 생성하고 계정과 연결하세요. 다른 사람들에게 보여주고 싶은 당신의 모습과 정보들로 프로필 페이지를 작성해봐요!'
    },
    {
        id: 2,
        img: img2,
        title: 'Buy your TOY KI',
        desc: '아바타를 기반으로 3D로 정교하게 제작된 TOY KI를 구매하여 키링으로 활용하세요. TOY KI 속에 있는 통신 칩은 다른 사람들이 당신과 연결될 수 있는 열쇠의 역할을 합니다.'
    },
    {
        id: 3,
        img: img3,
        title: 'Create social collection',
        desc: '근처에 TOY KI를 지니고 있는 사람에게 메세지를 전송해봐요. 우리 서비스의 유저가 아니더라도 TOY KI를 모바일 폰과 연동시켜 당신의 세계에 누구든지 초대할 수 있어요!'
    },
    {
        id: 4,
        img: img4,
        title: 'Sell your TOY KI',
        desc: '당신의 아트토이와 아이템을 마켓에 론칭하여 다른 사람들에게 판매할 수 있어요. 이외에도 다양한 브랜드와 협업한 한정판 아이템도 얻을 수 있어요.'
    },


]

export default dataPortfolio;